import { analytics } from "@heycatch/sdk";

// Identity + business events only. Autocapture handles pageviews/clicks/route changes.
export const identify = (user) => {
  if (!user?.user_id) return;
  analytics.setIdentity(
    user.user_id,
    { email: user.email, name: user.name, plan: user.has_course_access ? "course" : "free" },
    user.created_at ? { signup_date: user.created_at } : undefined,
  );
};

export const resetIdentity = () => analytics.resetIdentity();

export const track = (event, props) => analytics.trackEvent(event, props);
